import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=a3d08c12&"
import script from "./Installation.vue?vue&type=script&lang=js&"
export * from "./Installation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports